module.exports = __webpack_public_path__ + "img/bg_m.05ec8cf1.jpg";